import {TFunction} from 'i18next';
import {object, SchemaOf, string} from 'yup';
import {Merchant} from '../../../shared/model/Merchant.model';

export type SettlementFormFields = {
  recipientName: string;
  recipientAddress: string;
  institutionCode: string;
  accountNo: string;
};

export const settlementInitForm = (
  merchant: Merchant
): SettlementFormFields => ({
  recipientAddress: merchant?.recipientAddress ?? '',
  recipientName: merchant?.recipientName ?? '',
  institutionCode: merchant?.institutionCode ?? '',
  accountNo: merchant?.accountNo ?? ''
});

export const settlementValidationSchema = (t: TFunction): SchemaOf<SettlementFormFields> =>
  object({
    institutionCode: string().required(t('SHARED.FIELD_REQUIRED')),
    recipientName: string()
      .required(t('SHARED.FIELD_REQUIRED'))
      .max(100, t('SHARED.FIELD_MAX_CHAR', {max: 100})),
    recipientAddress: string()
      .required(t('SHARED.FIELD_REQUIRED'))
      .max(50, t('SHARED.FIELD_MAX_CHAR', {max: 50})),
    accountNo: string()
      .required(t('SHARED.FIELD_REQUIRED'))
      .max(50, t('SHARED.FIELD_MAX_DIGITS', {max: 50}))
  }).defined();
